const selectModule = (store) => store.appState.settings?.modules?.matomoModule;

// eslint-disable-next-line import/prefer-default-export
export const selectIsActive = (store) => selectModule(store)?.settings?.isActive;
